import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { secondaryText } from 'styles/theme';

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    gap: 2.4rem;
    height: 100%;
    color: ${secondaryText};
    font-size: 2rem;
    font-weight: 500;
    line-height: 1.2;
`;

export const Icon = styled(FontAwesomeIcon)`
    font-size: 4.8rem;
    color: ${secondaryText};
`;
